import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import sortBy from 'lodash/sortBy';

export default function useVisibility(
    positionsContainerId,
    categoryIdFieldName,
    offset = 0,
    throttleMilliseconds = 500
) {
    const [visibleItem, setIsVisible] = useState(null);

    const onScroll = throttle(() => {
        const currentElement = document.getElementById(positionsContainerId);

        if (!currentElement) {
            return;
        }

        const children = currentElement.querySelectorAll('*');

        const firstVisibleCategory = sortBy(Array.from(children)
            .map((child) => {
                const { top, bottom } = child.getBoundingClientRect();

                return {
                    top,
                    bottom,
                    categoryId: child.getAttribute(categoryIdFieldName)
                };
            }), ({
            top
        }) => top)
            .find(({ top, bottom, categoryId }) => categoryId && ((top + offset >= window.innerHeight) || (bottom - offset > 0)));

        if (firstVisibleCategory) {
            const element = {
                categoryId: firstVisibleCategory.categoryId
            };

            if (element.categoryId !== visibleItem?.categoryId) {
                setIsVisible(element);
            }
        }
    }, throttleMilliseconds);

    useEffect(() => {
        const restaurantContainer = window;

        restaurantContainer.addEventListener('scroll', onScroll);
        return () => restaurantContainer.removeEventListener('scroll', onScroll);
    });

    return visibleItem;
}
